import React from 'react';
import PropTypes from 'prop-types';
import ExperienceLevelCheckBox from './ExperienceLevelCheckBox';

function ExperienceLevelFilter({ experienceLevels, onExperienceLevelToggle }) {
  return (
    <div>
      {experienceLevels.map((experienceLevel) => (
        <ExperienceLevelCheckBox
          key={experienceLevel.type}
          experienceLevel={experienceLevel}
          onExperienceLevelToggle={() =>
            onExperienceLevelToggle(experienceLevel)
          }
          checked={experienceLevel.isChecked}
        />
      ))}
    </div>
  );
}

ExperienceLevelFilter.propTypes = {
  experienceLevels: PropTypes.array,
  onExperienceLevelToggle: PropTypes.func,
};

ExperienceLevelFilter.defaultProps = {
  experienceLevels: null,
  onExperienceLevelToggle: null,
};

export default ExperienceLevelFilter;
